import {
  ClassifierExcelUrl,
  ClassifierUploadSection,
  Popconfirm,
} from '@atlas-frontend/sdk';
import { FC, MouseEventHandler, ReactElement } from 'react';
import { expand } from 'uri-template-lite';
import translations from './ClassifierUpload.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, useTranslation } = i18nNsFactory('classifier-upload');
addTranslations(translations);

export interface ClassifierDownloadProps {
  classifierId: number;
  sections: ClassifierUploadSection[];
  confirmMessage?: string;
  children: ReactElement<{ onClick?: MouseEventHandler<HTMLElement> }>;
}

export const ClassifierDownload: FC<ClassifierDownloadProps> = ({
  children,
  classifierId,
  sections,
  confirmMessage,
}) => {
  const { t } = useTranslation();
  const renderDownload = (children: React.ReactNode) => (
    <a
      id={`classifier-${sections.join('-')}-download`}
      download
      href={expand(ClassifierExcelUrl, {
        id: classifierId,
        sections,
      })}
    >
      {children}
    </a>
  );

  return confirmMessage ? (
    <Popconfirm
      id={`confirm-download-classifier-${sections.join('-')}`}
      title={confirmMessage}
      description={t('description')}
      okText={renderDownload(t('button.yes'))}
      cancelText={t('button.no')}
      style={{ maxWidth: 300 }}
    >
      {children}
    </Popconfirm>
  ) : (
    renderDownload(children)
  );
};
